import React from 'react';
import {
    Input,
    Icon,
    Col, Row,
    Table,
    Pagination,
    Button,
    Tooltip,

    Form,
    Modal
} from 'antd';
const {Search} = Input;
import AsyncAppHOCFN  from '../AsyncAppHOC'
import style from './index.less'
const FormItem=Form.Item;
import {getOptionsByDictionary,changeByDictionary} from '../utils/common';
const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};
import IntlWrap from '../intlWrap'
@Form.create({})
class Warehouse extends React.Component {
    /**
     * 构造方法
     * @param props
     */
    static getDerivedStateFromProps(nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            if(!nextProps.value){
                return {
                    value: '',
                    valueStr:''
                };
            }
            return {
                value:nextProps.value || '',
            };
        }
        return null;
    }

    constructor(props) {
        super(props);
        const value = props.value ||'';
        this.state={
            value,
            valueStr:'',
            visible: false,
            params:{
                page:{
                    pageNumber: 1,
                    pageSize: 10,
                },
                "warehouseId": "",
                "warehouseName": ''
            },
            selectedRowKeys:[],
            selectedRows:[],
            total:0,
            tableDateList:[]
        }
    }



    /**
     * 组件渲染之后执行
     */
    componentDidMount() {
        let {params}=this.state;
        this.dispatchRequet(params,true)
    }
    openModal=()=>{
        this.setState({
            visible: true,
            selectedRowKeys:[],
            selectedRows:[],
        });
    };
    hideModal = () => {
        this.setState({
            visible: false,
        });
    };
    clear=()=>{
        let {onChange}=this.props;
        if(onChange){
            onChange('');
            this.setState({
                valueStr:''
            })
        }
    };
    confirm=()=>{
        let {onChange}=this.props;
        let {selectedRows}=this.state;
        if(onChange){
            if(!selectedRows.length){
                onChange('');
            }else{
                let valueObj=selectedRows.map((r)=>{
                    return {warehouseId:r.warehouseId,warehouseName:r.warehouseName}
                });
                let value=valueObj.map((r)=>{
                    return r.warehouseId
                }).join(',');
                let valueStr=valueObj.map((r)=>{
                    return r.warehouseName
                }).join('、')
                this.setState({
                    valueStr
                })
                onChange(value)
            }
        }
        this.hideModal()
    };
    /**
     * 第几页事件
     * @param current
     * @param limit
     */
    handlePageNumChange = (current, limit) => {
        let {params}=this.state;
        params.page = {
            pageSize:limit,
            pageNumber:current
        };
        this.setState({
            selectedRowKeys:[],
            selectedRows:[],
            params
        });
        this.dispatchRequet(params)
    }


    /**
     * 每页记录数事件
     * @param current
     * @param limit
     */
    handlePageSizeChange = (current, limit) => {
        let {params}=this.state;
        params.page = {
            pageSize:limit,
            pageNumber:current
        };
        this.setState({
            selectedRowKeys:[],
            selectedRows:[],
            params
        });
        this.dispatchRequet(params)
    };
    /**
     * 查询按钮点击事件
     */
    handleSearch = () => {

        this.props.form.validateFields(['warehouseName'],(err, values) => {
            if(!err){
                let {warehouseName}=values;
                let params={
                    page:{
                        pageNumber: 1,
                        pageSize: 10,
                    },
                    warehouseName:warehouseName,
                    warehouseId:warehouseName
                };
                this.dispatchRequet(params);// eslint-disable-line react/destructuring-assignment
                this.setState({
                    params,
                    selectedRowKeys:[],
                    selectedRows:[],
                    total:0
                })
            }
        });
    }
    dispatchRequet=(params,isfirst)=>{
        const {dispatch,getDate,locale} = this.props;
        getDate(
            {
                name:'getBusinessDate',
                url:'http://192.168.3.80:10201/api/101119101',
                params:params,
                locale
            },()=>{
                let {getBusinessDate}=this.props;
                this.setState({
                    tableDateList:getBusinessDate&&getBusinessDate.posts&&getBusinessDate.posts.page&&getBusinessDate.posts.page.content||[],
                    total:getBusinessDate&&getBusinessDate.posts&&getBusinessDate.posts.page&&getBusinessDate.posts.page.totalRecords||0,
                },()=>{
                    if(isfirst){
                        let {value}=this.props;
                        let {tableDateList}=this.state;
                        let valueStr=''
                        tableDateList.map((r)=>{
                            if(value==r.warehouseId){
                                valueStr= r.warehouseName;
                                this.setState({
                                    valueStr
                                })
                            }
                        })
                    }
                })
            })
    }
    render(){
        let {value,visible,params,selectedRowKeys,tableDateList,total,valueStr}=this.state;
        let {page}=params;
        const columnV=[
            {
                title: '序号',
                render:(text, record, index)=>{
                    return index-0+1
                },
                width: 80,
            },
            {
                title:'仓库编码',
                key: 'warehouseId',
                dataIndex:'warehouseId',
                width: 150,
                textWrap: 'word-break',
            },
            {
                title:'仓库名称',
                key: 'warehouseName',
                dataIndex:'warehouseName',
                width: 150,
                textWrap: 'word-break',
            },
            {
                title:'仓库详细地址',
                key: 'address',
                dataIndex:'address',
                textWrap: 'word-break',
                width: 200,
            },
        ];
        let rowSelection ={ rowSelection:{
                selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.setState({
                        selectedRowKeys, selectedRows
                    });
                }
            }};
        let {isMultiselect=false,disabled=false}=this.props;
        if(!isMultiselect){
            rowSelection={}
        }
        const { getFieldDecorator } = this.props.form;
        const loading=this.props.loading;
        return(
            <div >
                <Modal
                    title=""
                    visible={visible}
                    onOk={this.confirm}
                    onCancel={this.hideModal}
                    okText="确认"
                    cancelText="取消"
                    width='800px'
                >
                    <Form
                        className="ant-advanced-search-form"
                    >
                        <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
                            <Col sm={{span:24}} md={{span:16}} lg={{span:16}} xl={{span:16}}  key ='1'>
                                <FormItem {...formItemLayout} label={<></>}  colon={false} >
                                    {getFieldDecorator(`warehouseName`)(
                                        <Search
                                            placeholder="仓库编码/名称模糊查询"
                                            enterButton="查询"
                                            onSearch={this.handleSearch}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    <Table
                        {...rowSelection}
                        loading={loading}
                        pagination = {false}
                        bordered
                        columns={columnV}
                        dataSource={tableDateList}
                        scroll={{ x: '100%' ,y: 300}}
                        onRow={record => {
                            return {
                                onDoubleClick: event => {
                                    let {onChange}=this.props;
                                    if(onChange&&typeof onChange=="function"){
                                        let {warehouseId,warehouseName}=record;
                                        console.log([{warehouseId,warehouseName}],'asdasdasda')
                                        this.setState({
                                            valueStr:warehouseName
                                        })
                                        onChange(warehouseId)
                                    }
                                    this.hideModal()

                                },
                            }}}
                    />
                    <div className="pagina" style={{marginTop:'20px'}}>
                        <Pagination
                            showSizeChanger
                            showQuickJumper
                            onChange={this.handlePageNumChange}
                            onShowSizeChange={this.handlePageSizeChange}
                            pageSize={page.pageSize}
                            current={page.pageNumber}
                            showTotal={total => `共 ${total} 条`}
                            total={total}
                        />
                    </div>
                </Modal>
                {
                    disabled?<Input disabled={disabled} value={valueStr}/>:<Search
                    disabled={disabled}

                    placeholder="请选择仓库"
                    title={valueStr}
                    readOnly
                    value={valueStr}
                    enterButton="选择"
                    onSearch={this.openModal}
                    suffix={
                        (valueStr&&!disabled)?<Tooltip title="清除">
                            <Icon type="close-circle" onClick={this.clear} style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>:null
                    }
                />}
            </div>
        )
    }
}


export default IntlWrap(AsyncAppHOCFN(Warehouse));